// extracted by mini-css-extract-plugin
export default {"wrapper":"AppSidebar_wrapper__VpIF+","sidebarTriggerWrapper":"AppSidebar_sidebarTriggerWrapper__Gmde3","listIcon":"AppSidebar_listIcon__Y5W3I"};